import { Field, ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type B01HeroBannerProps = RenderingProps<B01HeroBannerFields, B01HeroBannerRenderingParams>;

export type B01HeroBannerFields = {
  BackgroundImage?: ImageField;
  MobileBackgroundImage?: ImageField;
  Heading?: Field<string>;
  SupportingCopy?: RichTextField;
  FirstCTALink?: LinkField;
  SecondCTALink?: LinkField;
};

export type B01HeroBannerRenderingParams = {
  HideImageOnMobile?: boolean;
  LeftAlignOnMobile?: boolean;
  BackgroundGradientLevel?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
